<template>
  <div>
    <Cascader :data="dist6" v-model="distValue" v-bind="$attrs" @on-change="change"
              :load-data="dist6.getChildren"></Cascader>
  </div>
</template>
<script>
  import {dict} from '@/libs'

  export default {
    model: {prop: 'value', event: 'change'},
    props: {
      value: String,
    },
    data() {
      return {
        dist6: [],
      }
    },
    computed: {
      distValue: {
        get() {
          return dict.dist6(this.value)
        },
        set(val) {
        }
      }
    },
    methods: {
      change(val) {
        this.$emit('change', dict.getDist6Res(val))
        this.$emit('on-change', dict.getDist6Res(val))
      }
    },
    created() {
      setTimeout(() => {
        dict.distByDict('sys.dist.support').then(payload => {
          this.dist6 = payload;
          console.log("dist6=", payload)
        })
      })
    }
  }
</script>